import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { Collapse } from '@material-ui/core';

const useStyles = makeStyles(({ spacing }) => ({
  nested: {
    paddingLeft: spacing(4)
  }
}));

const NestedNavList = ({ navItem, onClickNav }) => {
  const { subNavs, text } = navItem;
  const classes = useStyles({})
;
  const [open, setOpen] = useState(false);
  return (
    <>
      <ListItem button onClick={() => setOpen(!open)}>
        <ListItemText primary={text} primaryTypographyProps={{ variant: 'button' }} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {subNavs.map(({ text, route }) => (
            <ListItem key={text} button onClick={() => onClickNav(route)} className={classes.nested}>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List>
      </Collapse>
    </>
  );
};

export default NestedNavList;
